import { Moon, Sun } from 'lucide-react';
import { useAppDispatch, useAppSelector } from 'hooks/useAppStore';
import { toggleTheme } from 'app/providers/themeSlice';
import { useParashariPreferencesOptional } from 'schools/parashari/hooks/useParashariPreferencesSync';
import { Button } from 'components/ui/Button';
import { cn } from 'utils/cn';

type LearnerChromeControlsProps = {
  isDark: boolean;
  onToggleTheme?: () => void;
  className?: string;
  showThemeToggle?: boolean;
};

export function LearnerChromeControls({
  isDark,
  onToggleTheme,
  className,
  showThemeToggle = true,
}: LearnerChromeControlsProps) {
  const dispatch = useAppDispatch();
  const resolved = useAppSelector((s) => s.theme.resolved);
  const preferences = useParashariPreferencesOptional() as {
    handleToggleTheme?: () => void;
  } | null;

  const handleToggleTheme =
    onToggleTheme ??
    preferences?.handleToggleTheme ??
    (() => {
      dispatch(toggleTheme());
    });

  return (
    <div className={cn('flex items-center gap-1', className)}>
      {showThemeToggle ? (
        <Button
          variant="ghost"
          size="sm"
          onClick={handleToggleTheme}
          aria-label="Toggle theme"
          className="shrink-0"
        >
          {resolved === 'dark' ? <Sun className="h-4 w-4" /> : <Moon className="h-4 w-4" />}
        </Button>
      ) : null}
    </div>
  );
}
